import { render, staticRenderFns } from "./SumForm.vue?vue&type=template&id=5a6e2cb2&scoped=true&"
import script from "./SumForm.vue?vue&type=script&lang=js&"
export * from "./SumForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6e2cb2",
  null
  
)

export default component.exports